define('app/views/menu-detail',['require','./menu-list'],function(require){

  var MenuList = require('./menu-list');

  return MenuList.extend({

    view: 'menu_detail'

  });

});
